/*
 * parallax-media.js — parallax suave y genérico para imágenes grandes
 * (banners editoriales, splits). Envuelve la <img> real; no aporta layout
 * propio (display: contents en CSS), solo la desplaza levemente según el
 * scroll. Throttle por requestAnimationFrame. Respeta prefers-reduced-motion.
 *
 * Uso: <parallax-media data-strength="30"><img class="..." ...></parallax-media>
 * data-strength = desplazamiento máximo total en px (por defecto 24).
 */
if (!customElements.get('parallax-media')) {
  customElements.define(
    'parallax-media',
    class ParallaxMedia extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.img = this.querySelector('img');
        if (!this.img) return;

        this.strength = parseFloat(this.dataset.strength) || 24;
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      }

      update() {
        const rect = this.img.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const progress = Math.min(Math.max((vh - rect.top) / (vh + rect.height), 0), 1);
        const shift = (progress - 0.5) * this.strength;
        this.img.style.transform = `translate3d(0, ${shift.toFixed(1)}px, 0) scale(1.1)`;
      }
    }
  );
}
